import * as React from 'react';

export const ReleaseStepInactiveContext = React.createContext(false);
